import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  p {
    font-size: 1.6rem;
    color: ${p => p.theme.textColor};
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  max-width: 50rem;
  text-align: center;

  h2 {
    font-size: 2.4rem;
    color: ${p => p.theme.errorColor || '#e74c3c'};
    margin: 0;
  }

  p {
    font-size: 1.6rem;
    color: ${p => p.theme.textColor};
    margin: 0;
  }

  button {
    background-color: ${p => p.theme.primaryColor};
    color: ${p => p.theme.primaryTextColor};
    border: none;
    border-radius: 0.4rem;
    padding: 1.2rem 2.4rem;
    font-size: 1.6rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      opacity: 0.9;
    }

    &:active {
      transform: translateY(0.1rem);
    }
  }
`;

export const PDFContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  max-width: 60rem;
  text-align: center;

  p {
    font-size: 1.6rem;
    color: ${p => p.theme.textColor};
    line-height: 2.4rem;
  }

  button {
    background-color: ${p => p.theme.primaryColor};
    color: ${p => p.theme.primaryTextColor};
    border: none;
    border-radius: 0.4rem;
    padding: 1.2rem 2.4rem;
    font-size: 1.6rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      opacity: 0.9;
    }

    &:active {
      transform: translateY(0.1rem);
    }
  }
`;
